import styled from 'styled-components';
import { rgba } from 'polished';
import colors from '../../../constants/colors';
import ilConfirmation from '../../../assets/icons/ic_session_info.svg';
import icCloseBlack from '../../../assets/icons/ic_close_black.svg';
import { Background } from '../styles';
import Button from '../../Button';

export const BackgroundStyled = styled(Background)``;

export const Content = styled.div`
  background-color: ${colors.main.white};
  width: 610px;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 2px;
  opacity: 0.99;
  animation: fadein 1s;
  animation-delay: 0.3s;
  animation-fill-mode: backwards;
  z-index: 10002;
  @media screen and (max-width: 992px) {
    animation: easein 1s;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }

  @keyframes fadein {
    0% {
      opacity: 0;
    }
    20% {
      opacity: 0.2;
    }
    40% {
      opacity: 0.4;
    }
    60% {
      opacity: 0.6;
    }
    80% {
      opacity: 0.8;
    }
    85% {
      opacity: 0.8;
    }
    90% {
      opacity: 0.9;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes easein {
    from {
      transform: translate(-50%, 140%);
    }
    to {
      transform: translate(-50%, -50%);
    }
  }
`;

export const TextWrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-top: 8px;
  width: 344px;
`;

export const SubTextWrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 289px;
`;

export const Picture = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 150px;
  height: 155px;
  margin-top: 50px;
  background: url(${ilConfirmation});
  background-size: cover;
  @media screen and (max-width: 992px) {
    margin-top: 0;
  }
`;
export const CloseIcon = styled.div`
  width: 25px;
  height: 25px;
  background: url(${icCloseBlack});
  position: absolute;
  top: 0;
  right: 0;
  margin: 15px 15px 0 0;
  cursor: pointer;
`;

const StyledButton = styled(Button)`
  height: 40px;
  width: 140px;

  @media screen and (max-width: 992px) {
    box-shadow: none;
    position: fixed;
    bottom: 0;
    border-radius: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 1000;
  }
`;

export const ButtonCancel = styled(StyledButton)`
  color: ${colors.main.grey};
  background: ${colors.main.secondaryBtns};
  box-shadow: 0 0 60px ${rgba(colors.main.grey, 0.4)};

  &:hover,
  &:active {
    background: ${colors.main.secondaryBtns};
  }

  @media screen and (max-width: 992px) {
    box-shadow: none;
    bottom: 42px;
  }

  @media screen and (min-width: 766px) {
    &:hover,
    &:active {
      background: ${colors.main.secondaryBtns}!important;
      box-shadow: none;
    }
  }
`;

export const ButtonAccept = styled(StyledButton)`
  background: ${colors.main.green};
  margin-right: 19px;

  &:hover,
  &:active {
    background: ${colors.main.green};
  }

  @media screen and (min-width: 766px) {
    &:hover,
    &:active {
      background: ${colors.main.green}!important;
      box-shadow: none;
    }
  }
`;

export const Controls = styled.div`
  margin: 20px 0;
  display: flex;
  padding: 10px;
  justify-content: center;
`;

export const H2 = styled.h2`
  margin-bottom: 10px;
`;
